var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('money-give-outs-approved-list-infinity-scroll',{attrs:{"filters":{exclude__status: 'canceled', is_completed: false}}})}
var staticRenderFns = []

export { render, staticRenderFns }